import * as React from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import FindCompany from '../../../../../../components/find-company'
import styles from './hero.module.scss'

interface IHeroProps {
  onSubmit: (company: { name: string; orgNr: string; city: string; companyCode: string }) => void
  handleClickNotYetStarted: () => void
  initialName?: string | null
}

function Hero({ onSubmit, handleClickNotYetStarted, initialName }: IHeroProps) {
  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          <h1>
            <FormattedHTMLMessage defaultMessage="Analys av ditt företag" id="sync-bankstep1.hero.heading" />
          </h1>
          <p>
            <FormattedHTMLMessage
              defaultMessage="Via den här guiden kommer vi hämta information om ditt företag från Skatteverket och din bank. Då kan vi göra en rättvis bedömning av ditt företag och ta fram ett pris som utgår ifrån din verksamhet."
              id="sync-bankstep1.hero.subheading"
            />
          </p>
          <div className={styles.findCompanyWrapper}>
            <FindCompany
              handleClickNotYetStarted={() => handleClickNotYetStarted()}
              header={
                <FormattedHTMLMessage
                  defaultMessage="Ange ditt företagsnamn"
                  id="sync-bankstep1.hero.findCompany.label"
                />
              }
              initialName={initialName}
              onSubmit={(company: { name: string; orgNr: string; city: string; companyCode: string }) =>
                onSubmit(company)
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero
